import { render, staticRenderFns } from "./textElemtent.vue?vue&type=template&id=cbf21386&scoped=true"
import script from "./textElemtent.vue?vue&type=script&lang=js"
export * from "./textElemtent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf21386",
  null
  
)

export default component.exports